/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionPermissionsUpdateRequest
 */
export interface SectionPermissionsUpdateRequest {
    /**
     * 
     * @type {Array<any>}
     * @memberof SectionPermissionsUpdateRequest
     */
    permissionIds?: Array<any> | null;
}

/**
 * Check if a given object implements the SectionPermissionsUpdateRequest interface.
 */
export function instanceOfSectionPermissionsUpdateRequest(value: object): value is SectionPermissionsUpdateRequest {
    return true;
}

export function SectionPermissionsUpdateRequestFromJSON(json: any): SectionPermissionsUpdateRequest {
    return SectionPermissionsUpdateRequestFromJSONTyped(json, false);
}

export function SectionPermissionsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionPermissionsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
    };
}

export function SectionPermissionsUpdateRequestToJSON(json: any): SectionPermissionsUpdateRequest {
    return SectionPermissionsUpdateRequestToJSONTyped(json, false);
}

export function SectionPermissionsUpdateRequestToJSONTyped(value?: SectionPermissionsUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionIds': value['permissionIds'],
    };
}

